import { render } from "./TheNotifications.vue?vue&type=template&id=53759623"
import script from "./TheNotifications.vue?vue&type=script&lang=js"
export * from "./TheNotifications.vue?vue&type=script&lang=js"

import "./TheNotifications.vue?vue&type=style&index=0&id=53759623&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__